import React, { useMemo } from 'react'
import styled from 'styled-components'
import ImageCarousel from 'LuxKit/Carousel/ImageCarousel'
import LightBox from 'LuxKit/Modal/LightBox'
import type { ImageParams } from 'components/Common/ResponsiveImage'

const StyledCarousel = styled(ImageCarousel)`
  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`

interface Props {
  review: App.Review
  initialIndex: number
}

const IMAGE_PARAMS: ImageParams = {
  fit: 'none',
  aspectRatio: 'auto',
  gravity: 'center',
  quality: 'best',
}

function UserReviewGallery(props: Props) {
  const { review, initialIndex } = props

  const slides = useMemo(() => {
    if (!review.photos) return []
    return review.photos.map((photo) => ({
      type: 'image',
      id: photo.imageId,
    }))
  }, [review])

  return (
    <LightBox>
      <StyledCarousel
        images={slides}
        imageParams={IMAGE_PARAMS}
        arrowBehaviour="always-visible"
        disablePlaceholders
        defaultIndex={initialIndex}
      />
    </LightBox>
  )
}

export default UserReviewGallery
